import {useMemo} from 'react';
import SendingPopup from '../../../component/sendingPopup/SendingPopup';
import {useSelector} from 'react-redux';
import {TState} from '../../../redux/store.type';
import {TShow} from '../../../component/prompotionPopup/PromotionPopup';
import useRestartXHR from '../../../hooks/useRestartXHR';
import {useSend} from '../../../component/sendingPopup/hooks/useSend';
import {createSendingProps} from '../../../component/sendingPopup/services/createSendingProps';
import {useSendData} from '../../../hooks/useSendData';
import {useTranslation} from 'react-i18next';
import {sendLeadsMessage} from '../../../redux/publish/publishActions';
import {saveMailing} from '../../../redux/mailing/mailingActions';

function LeadSendPopup({show}: {show: TShow}) {
    const leads = useSelector((state: TState) => state.branding.leads);
    const sendingXHR = useSelector((state: TState) => state.publish.sendLeadsXHR);
    const eid = useSelector((state: TState) => state.event.eid);
    const {t} = useTranslation('mailing');

    // Custom hooks for data management and send logic
    const {whatsappData, emailData, smsData, handleDataSave, whatsappTemplate} = useSendData({
        defaultSubject: t('subjectDefaultText'),
        defaultEmailBody: `${t('leadMessageTitle')}\n${t('mailingLeadDefaultText')}\n [ref_link]`,
        defaultSmsMessage: `${t('leadMessageTitle')}\n${t('mailingLeadDefaultText')}\n [ref_link]`,
        type: 'lead',
    });
    const saveData = useMemo(() => ({source: 'lead', eid}), [eid]);
    const {handleSend, handleSave} = useSend({whatsappData, emailData, smsData, show, sendFunction: sendLeadsMessage, saveFunction: saveMailing, data: {leads: leads}, saveData});

    // XHR restart hook
    useRestartXHR(sendingXHR, 'publish.sendLeadsXHR');

    // Create props using utility function
    const {whatsappProps, emailProps, smsProps} = createSendingProps({
        whatsappData,
        emailData,
        smsData,
        handleDataSave,
        handleSend,
        handleSave,
        sendingXHR,
        whatsappTemplate,
        variablesType: 'lead',
        mailingSource: 'lead',
    });
    
    return (
        <>
            {show.isOpen && whatsappTemplate && (
                <SendingPopup
                    show={show}
                    whatsappProps={whatsappProps}
                    smsProps={smsProps}
                    emailProps={emailProps}
                    amount={leads.length}
                    amountText={'leads'}
                    variablesType={'lead'}
                    allowedList={['whatsapp', 'email', 'sms']}
                />
            )}
        </>
    );
}

export default LeadSendPopup; 